import React from 'react';
import './home.css';

interface StatCardProps {
  percentage: string;
  label: string;
}

function StatCard({ percentage, label }: StatCardProps) {
  return (
    <div className="stat-card">
      <div className="stat-percentage">{percentage}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}
export default function Home() {
  return (
    <div className="landing-container">
      {/* Floating Background Elements */}
      <div className="floating-elements">
        {/* Large floating rectangles */}
        <div className="floating-rect floating-rect-1" />
        <div className="floating-rect floating-rect-2" />
        <div className="floating-rect floating-rect-3" />

        {/* Data visualization elements */}
        <div className="data-viz">
          {[...Array(8)].map((_, i) => (
            <div
              className="data-bar"
              style={{
                width: `${20 + Math.random() * 40}px`,
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </div>

        {/* Chart-like elements */}
        <div className="chart-elements">
          {[...Array(12)].map(() => (
            <div
              className="chart-bar"
              style={{
                height: `${10 + Math.random() * 30}px`,
              }}
            />
          ))}
        </div>

        {/* Small floating elements */}
        <div className="floating-dot floating-dot-1" />
        <div className="floating-dot floating-dot-2" />
        <div className="floating-dot floating-dot-3" />
      </div>

      {/* Abstract face silhouette */}
      <div className="face-silhouette">
        <div className="face-container">
          <div className="face-gradient-1" />
          <div className="face-gradient-2" />
        </div>
      </div>

      <nav className="navigation">
        {/* Logo aligned left */}
        <img src="/whiteLogo.svg" alt="DigitalGov Logo" className="logoWhite" />

        {/* Nav links & user access grouped */}
        <div className="nav-wrapper">
          <div className="nav-menu">
            <a href="/" className="nav-link nav-link-active">Home</a>
            <span className="arrow">›</span>
            <a href="/" className="nav-link">About</a>
            <span className="arrow">›</span>
            <a href="/" className="nav-link">Features</a>
            <span className="arrow">›</span>
            <a href="/" className="nav-link">Services</a>
          </div>

          <div className="nav-spacer" />

          <div className="logout-text">
            <a href="/login">
              User access
              {' '}
              <img src="/userLogo.svg" alt="userLogo" className="user-icon" />
            </a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="main-content">
        <div className="content-container">
          <div className="content-grid">
            {/* Left Content */}
            <div className="left-content">
              <h1 className="main-title">
                Transforming the Future
                <br />
                <span className="gradient-text">
                  of Public Service
                </span>
              </h1>

              <div className="info-card">
                <p className="info-text">
                  With a sleek and modern aesthetic, your landing page resonates
                  with ambition and professionalism, emphasizing innovation as
                  the cornerstone of success.
                </p>

                <div className="sustainability-indicator">
                  <div className="indicator-dot" />
                  <span className="indicator-text">Sustainable</span>
                </div>

                <div className="progress-container">
                  <div className="progress-bar" />
                </div>
              </div>

              {/* Statistics */}
              <div className="stats-container">
                <StatCard percentage="85%" label="Driving Digital Success" />
                <StatCard percentage="23%" label="Empowering Growth" />
              </div>
            </div>

            {/* Right Content - Stats Display */}
            <div className="right-content">
              <div className="stats-display">
                <div className="stats-inner">
                  <div className="big-stat">10+</div>
                  <div className="big-stat-label">
                    Through
                    <br />
                    Innovation
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="bottom-gradient" />
    </div>
  );
}
